// extracted by mini-css-extract-plugin
export default {"Key":"Key_Key__sjJzj"};